import { render, staticRenderFns } from "./historyWith.vue?vue&type=template&id=08c30dab&scoped=true&"
import script from "./historyWith.vue?vue&type=script&lang=js&"
export * from "./historyWith.vue?vue&type=script&lang=js&"
import style0 from "./historyWith.vue?vue&type=style&index=0&id=08c30dab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c30dab",
  null
  
)

export default component.exports